import { useBlocker } from 'react-router'
import { useCallback, useEffect } from 'react'
import { type DocumentBlockerStore } from 'pages/settings/pages/knowledgeBase/store/documentBlockerStore'

export const useDocumentBlocker = (store: DocumentBlockerStore) => {
  const { isExistChanges, handleShowBlockerModal } = store
  const blocker = useBlocker(() => isExistChanges)

  const beforeUnloadHandler = useCallback((event: BeforeUnloadEvent) => {
    event.preventDefault()
  }, [])

  useEffect(() => {
    return () => {
      window.removeEventListener('beforeunload', beforeUnloadHandler)
    }
  }, [])

  useEffect(() => {
    handleShowBlockerModal(blocker)
  }, [blocker])

  useEffect(() => {
    if (isExistChanges) {
      window.addEventListener('beforeunload', beforeUnloadHandler)
    } else {
      window.removeEventListener('beforeunload', beforeUnloadHandler)
    }
  }, [isExistChanges])
  return null
}
